import { isMacPlatform } from '../../../core/utils/user-agent-utils.js';

/**
 * Zoom mode is triggered by holding Ctrl or Cmd (`event.metaKey || event.ctrlKey`),
 * but Ctrl+Arrow is intercepted by macOS Mission Control by default, so Cmd is the
 * only modifier that reliably reaches the browser there.
 * @internal
 */
export function getPrimaryModifierKey(): 'meta' | 'control' {
  return isMacPlatform() ? 'meta' : 'control';
}
